import {IIdioma} from "services-comun/modules/net/idiomas";

import {Idiomas} from "../idioma";
import {ITraduccion, Traduccion} from "../traduccion";

export interface ITraduccionMapValues {
    defecto?: string;
    valores: NodeJS.Dict<string>;
}

// export type ITraduccionMap = Partial<ITraduccion<ITraduccionMapValues>>;
export type ITraduccionMap = ITraduccion<ITraduccionMapValues>;

export interface ITraduccionMapKeys {
    [key: string]: string;
}

export class TraduccionMap<T extends Record<string, string>={}> extends Traduccion<ITraduccionMapValues, T> {
    /* STATIC */
    public static completar({valor, defecto}: Partial<ITraduccionMap>, idiomas: Idiomas): ITraduccionMap {
        const vertical = this.fillVertical(idiomas, valor, defecto);
        const horizontal = this.fillHorizontal(idiomas, vertical, defecto);

        // const set = new Set<string>();
        // for (const {valores} of Object.values(horizontal) as ITraduccionMapValues[]) {
        //     for (const key of Object.keys(valores)) {
        //         set.add(key);
        //     }
        // }
        // if (defecto!=undefined) {
        //     for (const key of Object.keys(defecto.valores)) {
        //         set.add(key);
        //     }
        // }
        // const keys = Array.from(set.values()).sort();

        return {
            valor: horizontal,
            defecto: defecto ?? {
                defecto: this.ID.toUpperCase(),
                valores: {},
            },
        };
    }

    public static build<T extends Record<string, string>={}>(lang: IIdioma, values: ITraduccionMap, params?: string[]): TraduccionMap<T> {
        return this.buildExec<ITraduccionMapValues, T>(lang, values, params) as TraduccionMap<T>;
    }

    /* INSTANCE */
    public render(key: string, params?: Partial<T>): string {
        return this.aplicarParams(this.valor.valores[key]??this.valor.defecto??this.id.toUpperCase(), params);
    }
}
